export default __webpack_public_path__ + "static/media/cafe.eadabf69.svg";